import React from 'react';
import PropTypes from 'prop-types';
import TableGrid from 'semantic-table-grid';
import { Grid, Divider } from 'semantic-ui-react';

import { PlusBtn, BtnWithActions } from 'components/Buttons';
import { Center } from 'components/Layout';
import Modal from 'components/Modal/';
import EmptyMessage from '../../UI/EmptyMessage';

// Temporary fix: https://github.com/Semantic-Org/Semantic-UI-React/issues/1157
const fixBody = () => {
  setTimeout(() => document.body.classList.add('scrolling'), 0);
};

export default class AddableModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpened: false,
      currentObj: null,
    };
  }

  getActions = (data) =>
    [
      {
        icon: 'edit',
        label: 'Modifica',
        action: () => this.openModalEdit(data),
      },
      !this.props.hideDelete && {
        icon: 'remove',
        label: 'Elimina',
        action: () => {
          // eslint-disable-next-line
          confirm("L'elemento sta per essere cancellato e l'azione è irreversibile, continuare ?")
            ? this.props.onDelete(data)
            : null;
        },
      },
    ].filter(Boolean);

  baseColumns = [
    {
      key: 'Azioni',
      name: 'Azioni',
      formatter: ({ data }) =>
        (!this.props.conditionalHideEditOnRow || this.props.conditionalHideEditOnRow(data)) && (
          <Center>
            <BtnWithActions key="other-actions" actions={this.getActions(data)} otherActions={[]} />
          </Center>
        ),
      sortable: false,
    },
  ];

  closeModal = () => this.setState({ modalOpened: false, currentObj: null }, fixBody);

  openModal = () => {
    if (this.props.validateBeforeAdd || !this.props.validateBeforeAddEnabled) {
      this.setState({ modalOpened: true });
    } else {
      alert(this.props.validateBeforeAddMessage); // eslint-disable-line
    }
  };

  openModalEdit = (data) => this.setState({ modalOpened: true, currentObj: data });

  render() {
    const childrenWithExtraProps = React.cloneElement(this.props.children, {
      closeModal: this.closeModal,
      onChange: this.props.onChange,
      initialValues: this.state.currentObj,
    });

    return [
      <Grid key="toolbar">
        <Grid.Column width={16}>
          <Divider horizontal style={{ marginBottom: 5 }}>
            {this.props.sectionTitle}
            {!this.props.singleAddAllowed && !this.props.hideAdd && <PlusBtn action={this.openModal} />}
          </Divider>
          <Modal
            onClose={this.closeModal}
            size={this.props.modalSize}
            open={this.state.modalOpened}
            title={this.props.addModalTitle}
          >
            {childrenWithExtraProps}
          </Modal>
        </Grid.Column>
      </Grid>,
      <TableGrid
        key="tablegrid"
        columns={!this.props.hideEdit ? this.props.columns.concat(this.baseColumns) : this.props.columns}
        canSelect={false}
        canAction={this.props.canAction}
        elements={this.props.elements || []}
        hiddenHeaderIfEmpty
        isLoading={this.props.isLoading || false}
        emptyResults={<EmptyMessage>{this.props.emptyMessage}</EmptyMessage>}
      />,
    ];
  }
}

AddableModal.propTypes = {
  columns: PropTypes.array,
  elements: PropTypes.array,
  emptyMessage: PropTypes.string,
  addModalTitle: PropTypes.string,
  sectionTitle: PropTypes.string,
  children: PropTypes.object.isRequired,
  modalSize: PropTypes.string,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  validateBeforeAdd: PropTypes.bool,
  validateBeforeAddEnabled: PropTypes.bool,
  validateBeforeAddMessage: PropTypes.string,
  hideEdit: PropTypes.bool,
  hideDelete: PropTypes.bool,
  singleAddAllowed: PropTypes.bool,
  hideAdd: PropTypes.bool,
  canAction: PropTypes.object,
  isLoading: PropTypes.bool,
  conditionalHideEditOnRow: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Forms/UI/AddableModal/index.js